var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l_location"},[_c('div',{staticClass:"c_location"},[_c('div',{staticClass:"l_map"},[_c('g-map')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }